import React from "react";
import styles from './zoom-level.module.css'
import { useSelector } from "react-redux";

export default function ZoomLevel() {
    const { zoomLevel } = useSelector(state => state.map)
    return (
        <div className={styles.container}>
            Zoom level: {zoomLevel}
        </div>
    );
}